/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareLeftIcon20Light = forwardRef('ArrowFigureASquareLeftIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M13.5 9.5A.5.5 0 0 0 13 9H6.781l2.54-2.116a.5.5 0 1 0-.641-.768L6.002 8.348a1.5 1.5 0 0 0 0 2.304l2.678 2.232a.5.5 0 0 0 .64-.768L6.781 10H13a.5.5 0 0 0 .5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 5.5A3.5 3.5 0 0 0 13.5 2h-8A3.5 3.5 0 0 0 2 5.5v8A3.5 3.5 0 0 0 5.5 17h8a3.5 3.5 0 0 0 3.5-3.5v-8ZM13.5 3A2.5 2.5 0 0 1 16 5.5v8a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 3 13.5v-8A2.5 2.5 0 0 1 5.5 3h8Z" })));
});
